var exports = {
  "k": "x61f99309--43924f--container",
};

module.exports = exports;
